<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2 class="m-0">Contact Us</h2>
            <!-- <p>Drop us Message for any Query</p> -->
        </div>
    </div>
</div>

<section class="contact-area ptb-100">
    <div class="container">
        <div class="contact-inner">
            <div class="row">
                <div class="col-lg-6 col-md-12">
                    <div class="contact-features-list">
                        <h3>Some other great reasons to choose us</h3>
                        <p>Take the first steps towards increased productivity and reduced stress with Strax.</p>
                        <p>We are a highly trained, dedicated team, helping entrepreneurs, professionals, and small
                            teams streamline success - not just in work, but in life too. We help spare your time to
                            focus on the bigger picture by taking care of the little details.</p>
                    </div>
                    <div class="contact-features-list mt-4 pt-4">
                        <h3>Contact us by phone number or email address</h3>
                        <ul class="contact-pins">
                            <li>
                                <i class='bx bxs-phone-call'></i>
                                <a href="tel:+919408877110">(+91) 940 8877 110</a>
                            </li>
                            <li>
                                <i class='bx bxs-envelope'></i>
                                <a href="mailto:info&#64;kaimsit.com">info&#64;kaimsit.com</a>
                            </li>
                            <li>
                                <i class='bx bx-current-location'></i>
                                <a href="https://maps.app.goo.gl/AT6788joRPRqy5pd9" target="_blank">
                                    A-201, Aleeza Business Center, Ahmedabad - India
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="contact-form">
                        <h3>Write a Message</h3>
                        <form id="contactForm" [formGroup]="demoForm" (ngSubmit)="onSubmit()">
                            <div class="row">
                                <div class="col-lg-6 col-md-6 mb-3 position-relative">
                                    <div class="form-group">
                                        <input type="text" formControlName="name" id="name" class="form-control"
                                            placeholder="Your Name">
                                        <div *ngIf="submitted && f.name.errors"
                                            class="text text-danger text-left mt-0 font-weight-500 font-13 error-validation">
                                            <div *ngIf="f.name.errors.required">Name is required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 mb-3 position-relative">
                                    <div class="form-group">
                                        <input type="email" formControlName="email" id="email" class="form-control"
                                            placeholder="Your Email">
                                        <div *ngIf="submitted && f.email.errors"
                                            class="text text-danger text-left mt-0 font-weight-500 font-13 error-validation">
                                            <div *ngIf="f.email.errors.required">Email is required</div>
                                            <div *ngIf="f.email.errors.email">
                                                Email must be a valid email address
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12 mb-3 position-relative">
                                    <div class="form-group">
                                        <input type="text" formControlName="phone" id="phone" class="form-control"
                                            placeholder="Your Phone" (keypress)="numberOnly($event)">
                                        <div *ngIf="submitted && f.phone.errors"
                                            class="text text-danger text-left mt-0 font-weight-500 font-13 error-validation">
                                            <div *ngIf="f.phone.errors.required">
                                                Phone no. is required
                                            </div>
                                            <div *ngIf="f['phone'].errors['minlength']">
                                                Phone no. should be exact 10 characters.
                                            </div>
                                            <div *ngIf="f['phone'].errors['maxlength']">
                                                Phone no. should be exact 10 characters.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col-lg-6 col-md-6 mb-3 position-relative">
                                    <div class="form-group">
                                        <input type="text" formControlName="subject" id="subject" class="form-control"
                                            placeholder="Your Subject">
                                        <div *ngIf="submitted && f.subject.errors"
                                            class="text text-danger text-left mt-0 font-weight-500 font-13 error-validation">
                                            <div *ngIf="f.subject.errors.required">Subject is required</div>
                                        </div>
                                    </div>
                                </div> -->
                                <div class="col-lg-12 col-md-12 mb-3 position-relative">
                                    <div class="form-group">
                                        <textarea formControlName="message" class="form-control" id="message" cols="30"
                                            rows="6" placeholder="Your Message"></textarea>
                                        <div *ngIf="submitted && f.message.errors"
                                            class="text text-danger text-left mt-0 font-weight-500 font-13 error-validation">
                                            <div *ngIf="f.message.errors.required">Message is required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12">
                                    <button type="submit" class="default-btn"><i class='bx bxs-paper-plane'></i>Send
                                        Message<span></span></button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<hr />

<app-our-client></app-our-client>